import { EXTERNAL_BANDS } from "./SocTrendCharts";

// Which Security Operations trend series have a connected source, from the summary tiles. The trends
// endpoint always returns every series; a chart is drawn only when its source is connected, so a
// source that isn't connected never appears as a zero line. Shared by the Overview and the Trends
// section of the area views.
const EXTERNAL_RISK_KEYS = ["openEsmRisks", "openSecretsRisks", "openLeakedCredentials"];
// Event keys for the sources that raise ESM / SecretsScan / DarkWebExposure findings.
const EXTERNAL_FINDING_EVENT_KEYS = ["esmEvents", "secretsEvents", "darkWebEvents"];

export const isConnected = (tile) => !!tile && tile.status !== "notConnected" && tile.connected !== false;
export const hasKey = (tile, key) => Object.prototype.hasOwnProperty.call(tile?.metrics || {}, key);

export const trendSources = (tiles) => {
  const byKey = Object.fromEntries((tiles || []).map((t) => [t.key, t]));
  const external = byKey.external;
  const externalConnected = isConnected(external);
  return {
    // Defender XDR feeds the incidents, alerts, vulnerabilities and other-Defender series.
    defender: isConnected(byKey.incidents),
    externalRisks:
      externalConnected &&
      (EXTERNAL_FINDING_EVENT_KEYS.some((k) => hasKey(external, k)) ||
        EXTERNAL_RISK_KEYS.some((k) => (Number(external.metrics?.[k]) || 0) > 0)),
    bands: externalConnected ? EXTERNAL_BANDS.filter((b) => hasKey(external, b.metricKey)) : [],
    identity: hasKey(byKey.identity, "identities"),
    network: isConnected(byKey.network),
  };
};
